import {DateAsString} from '@/common/api/api-raw-types';
import {nl2br} from '@malt/common';
import {da} from 'date-fns/locale';

export const FormatHelper = {
    dateToSimpleDateString: (locale: string, date: Date): string => {
        return new Intl.DateTimeFormat(locale.toString(), {year: 'numeric', month: 'long'}).format(date);
    },
    textToHtmlFormattedText: (text: string): string => {
        return nl2br(text);
    },
};
